import { render } from "./confirmdialog.vue?vue&type=template&id=1a3eb5eb&scoped=true"
import script from "./confirmdialog.vue?vue&type=script&lang=js"
export * from "./confirmdialog.vue?vue&type=script&lang=js"

import "./confirmdialog.vue?vue&type=style&index=0&id=1a3eb5eb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a3eb5eb"]])

export default __exports__